module.exports = __webpack_public_path__ + "static/cppa-0a3943dfa2187e1ed3d07f39423ad768.png";